export default __webpack_public_path__ + "static/media/tianyang.1eec752a.jpg";